type GVLSpecV2_2Path = 'v3'
type Geo = string
type Platform = 'web'
type Latest = 'latest'
type NumberLike = string
type GVLSpecV2NonGeoVariant = [NumberLike]
type GVLSpecV2GeoVariant = [NumberLike, Geo, Platform]
type GVLSpecV2_2NonGeoVariant = [GVLSpecV2_2Path, number|Latest]
type GVLSpecV2_2GeoVariant = [GVLSpecV2_2Path, number|Latest, Geo, Platform]
export type GVLVersion =
  | GVLSpecV2NonGeoVariant
  | GVLSpecV2GeoVariant
  | GVLSpecV2_2NonGeoVariant
  | GVLSpecV2_2GeoVariant

export function isGVLSpecV2_2GeoVariant(
  versionTuple: GVLVersion
): versionTuple is GVLSpecV2_2GeoVariant {
  return versionTuple.length === 4
}

function isGVLSpecV2_2NonGeoVariant(
  versionTuple: GVLVersion
): versionTuple is GVLSpecV2_2NonGeoVariant {
  return versionTuple.length === 2
}

function isGVLSpecV2GeoVariant(
  versionTuple: GVLVersion
): versionTuple is GVLSpecV2GeoVariant {
  return versionTuple.length === 3
}

export function getMolGvlVersion(
  versionTuple: GVLVersion,
  vendorListVersion: number
): string {
  
  if (isGVLSpecV2_2GeoVariant(versionTuple)) {
    const [gvlSpecV2Path, , geo, platform] = versionTuple
    return `${gvlSpecV2Path}/${vendorListVersion}/${geo}/${platform}`
  }

  if (isGVLSpecV2_2NonGeoVariant(versionTuple)) {
    const [gvlSpecV2Path] = versionTuple
    return `${gvlSpecV2Path}/${vendorListVersion}`
  }

  if (isGVLSpecV2GeoVariant(versionTuple)) {
    const [, geo, platform] = versionTuple
    return `${vendorListVersion}/${geo}/${platform}`
  }

  return `${vendorListVersion}`
}

export function getFallbackMolGvlVersion(
  versionTuple: GVLVersion
): [string, GVLSpecV2NonGeoVariant | GVLSpecV2_2NonGeoVariant] | undefined {
  if (isGVLSpecV2_2GeoVariant(versionTuple)) {
    const [gvlSpecV2Path, version] = versionTuple
    return [`${gvlSpecV2Path}/${version}`, [gvlSpecV2Path, version]]
  }

  if (isGVLSpecV2GeoVariant(versionTuple)) {
    const [version] = versionTuple
    return [`${version}`, [version]]
  }
}
